import React, { Component } from 'react'

import includes from 'lodash/includes'
import PropTypes from 'prop-types'

import numberConverter from '../../../../utils/tuition/numberForCurrency'

export default class CollegeTuitionSearchResults extends Component {
  static propTypes = {
    data: PropTypes.any,
  }

  render() {
    const { data } = this.props
    const http = address => {
      return includes(address, 'http') ? address : `http://${address}`
    }
    return (
      <div>
        <div className="row m-0">
          <div>
            <h5 className="mb-0">
              <a
                href={http(data.url)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {data.instName}
              </a>
            </h5>
          </div>
          <div className="col-md-12 p-0">
            <div className="text-muted">
              {data.city}, {data.state}
            </div>
            {data.inStateTuition && (
              <div className="text-muted">
                {' '}
                4-Year Average Net Price ${numberConverter(data.inStateTuition)}
              </div>
            )}
            {data.tuitionUrl && (
              <a
                href={http(data.tuitionUrl)}
                target="_blank"
                rel="noopener noreferrer"
              >
                Net Price Calculator
              </a>
            )}
          </div>
          {/*<div className="col-md-4" style={{padding: '10px 0 0 0'}}>
            <img className="img-fluid" width="80px" src={data.logo || university } alt="Placeholder" />
          </div>*/}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Tuition/components/CollegeTuitionSearchResults.js